import { controls } from "../controls";


const tr004 = {
  label: "Day Close For Branch",
  pageLabel: "Day Close For Branch",
  starting: true,
  url: "tr004",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Current Open Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "current_open_date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Outward (Credit) Clearing", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "outward_credit_clearing", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Domain",
        accessor: "user",
        width: 150
      },
      {
        Header: "Open",
        accessor: "open",
        width: 150
      },


    ]
  }
}
export default tr004